import comp from "./StandardsDataGrid";
export default comp;
